export default {
    data() {
        return {
            items: [],
            originalItems: [],
            errorText: '',
            isShowErrorText: false,
            isLoading: false
        }
    },
    methods: {
        addItem() {
            this.items.push({ title: '' })
        },
        removeItem(index) {
            this.items.splice(index, 1)
        },
        updateOrder(action, index) {
            const item = this.items.splice(index, 1)[0]
            switch (action) {
                case 'FIRST':
                    this.items.unshift(item)
                    break
                case 'LAST':
                    this.items.push(item)
                    break
                case 'PREVIOUS':
                    if (index > 0) this.items.splice(index - 1, 0, item)
                    break
                case 'NEXT':
                    this.items.splice(index + 1, 0, item)
                    break
            }
            for (let i=0 ; i<this.items.length ; i++) {
                this.items[i].sortNum = i
            }
        },
        hideErrorText() {
            this.isShowErrorText = false
        },
        validateItems(itemProperty, message) {
            if (this.items.some((item) => !item[itemProperty])) {
                this.errorText = message['empty']
                this.isShowErrorText = true
                return false
            }
            if (new Set(this.items.map((item) => item[itemProperty])).size !== this.items.length) {
                this.errorText = message['duplicate']
                this.isShowErrorText = true
                return false
            }
            if (JSON.stringify(this.items) === JSON.stringify(this.originalItems)) {
                this.$store.dispatch('setToast', { isShow: true, text: message['noChange'] })
                return false
            }
            return true
        },
        async handleCreateItems(apiCreateMethod) {
            let createTasks = this.items.filter((item) => !item._id).map((item) => apiCreateMethod(item))

            return Promise.all(createTasks)
        }
    }
}
